<template>
  <b-columns>
    <b-column>
      <b-columns is-multiline>
        <b-column
          v-for="(item, idx) in items"
          :key="idx"
          class="is-full"
        >
          <b-columns>
            <b-column class="is-2 has-text-weight-semibold is-top-bottom-paddingless">{{ item.label }}:</b-column>
            <b-column class="is-top-bottom-paddingless">{{ item.value | nullToDash }} {{ item.unit || '' }}</b-column>
          </b-columns>
        </b-column>
      </b-columns>
    </b-column>
  </b-columns>
</template>

<script>
export default {
  name: 'KeyValueTable',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>

</style>
